export const environment = {
  production: true,
  baseApiUrl: 'https://api-t.roto-versal.com/',
  baseAppUrl: 'https://app-t.roto-versal.com/',
  env: 'test'
};
